export const isNegativeNumber = (number) => {
    return Math.sign(number) === -1
}